import React from 'react';
import PropTypes from 'prop-types';

const AttachmentsContext = React.createContext();

export const AttachmentsContextProvider = ({ children }) => {

    const [attachments, setAttachments] = React.useState({});

    const sortedAttachments = React.useMemo(
        () => Object.values(attachments).sort((a, b) => b.sortId - a.sortId),
        [attachments]
    );

    const upsertFile = React.useCallback(
        (attachment) => setAttachments((files) => {

            if (attachment.error) {

                setTimeout(() => { throw attachment.error; });

                const updatedFiles = { ...files };
                delete updatedFiles[attachment.id];
                return updatedFiles;
            }

            return { ...files, [attachment.id]: attachment };
        }),
        [setAttachments]
    );

    const removeFile = React.useCallback(
        (id) => setAttachments((files) => {
            const updatedFiles = { ...files };
            delete updatedFiles[id];
            return updatedFiles;
        }),
        [setAttachments]
    );

    const clearAttachments = React.useCallback(() => {
        Object.keys(attachments).forEach(removeFile);
    }, [attachments, removeFile]);

    return (
        <AttachmentsContext.Provider value={{
            attachments: sortedAttachments,
            upsertAttachment: upsertFile,
            removeAttachment: removeFile,
            attachmentsMap: attachments,
            clearAttachments
        }}>
            {children}
        </AttachmentsContext.Provider>
    );
};

AttachmentsContextProvider.propTypes = {
    children: PropTypes.node.isRequired
};

export const useAttachments = () => {
    const { attachmentsMap, ...attachments } = React.useContext(AttachmentsContext);
    return attachments;
};

export const useAttachment = (id) => {
    const { attachmentsMap } = React.useContext(AttachmentsContext);
    return attachmentsMap[id] || {};
};
